/* eslint-disable no-undef */
// prettier-ignore
import { styled } from '@mui/material';
import Button from '@mui/material/Button';

export const Styles = {
  RectangleBar: styled('div')(({ theme }) => ({
    margin: '0 auto',
    height: '8px',
    backgroundColor: '#D9D9D9',
    marginBottom: '35px',
    marginTop: '-25px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '25px',
      marginTop: '-15px'
    }
  })),

  SectionFilters: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: '25px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      gap: theme.spacing(2)
    }
  })),

  Button: styled('button')(({ theme }) => ({
    padding: '10px 20px',
    fontSize: '14px',
    backgroundColor: '#2C62C7',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#0B327A'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      order: 3,
      marginTop: theme.spacing(2)
    }
  })),

  FlexContainer: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px',
    [theme.breakpoints.down('md')]: {
      marginBottom: '0'
    }
  })),

  ShowText: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  SelectContainer: styled('div')(({ theme }) => ({
    select: {
      padding: '5px',
      fontSize: '16px',
      border: '0.5px solid #5D5F64',
      borderRadius: '5px',
      backgroundColor: '#F8F8F8',
      '&:focus': {
        outline: 'none',
        borderColor: '#04682E'
      },
      [theme.breakpoints.down('md')]: {
        fontSize: '14px',
        padding: '3px'
      }
    }
  })),

  RecordsText: styled('div')(({ theme }) => ({
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '17px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px'
    }
  })),

  SearchContainer: styled('div')(({ theme }) => ({
    marginRight: '10px',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '5px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      order: 2,
      marginRight: '0'
    }
  })),

  SearchInput: styled('input')(({ theme }) => ({
    width: '250px',
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #5D5F64',
    borderRadius: '5px',
    backgroundColor: '#F8F8F8',
    '&:focus': {
      outline: 'none',
      borderColor: '#04682E'
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      fontSize: '14px'
    }
  })),

  UserCard: styled('div')(({ theme }) => ({
    height: '75px',
    backgroundColor: '#FEF7FF',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    marginBottom: '20px',
    [theme.breakpoints.down('lg')]: {
      width: '100%'
    },
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: 'auto',
      padding: '15px',
      position: 'relative'
    }
  })),

  UserIcon: styled('div')(({ theme }) => ({
    width: '40px',
    height: '40px',
    backgroundColor: '#D9D9D9',
    borderRadius: '50%',
    marginRight: '15px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    '& img': {
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      objectFit: 'cover'
    },
    [theme.breakpoints.down('md')]: {
      position: 'absolute',
      top: '15px',
      left: '15px',
      width: '50px',
      height: '50px'
    }
  })),

  UserInfo: styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flex: 1,
    [theme.breakpoints.down('md')]: {
      marginLeft: '70px',
      width: 'calc(100% - 70px)',
      marginBottom: '15px'
    }
  })),

  UserName: styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '1px',
    color: '#212529',
    [theme.breakpoints.down('md')]: {
      lineHeight: '20px',
      marginBottom: '5px',
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: '5px'
    }
  })),

  Buttons: styled('div')(({ theme }) => ({
    display: 'flex',
    gap: '10px',
    paddingRight: '50px',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      paddingRight: '0',
      justifyContent: 'space-between'
    },
    '& button': {
      padding: '8px 16px',
      borderRadius: '5px',
      border: 'none',
      cursor: 'pointer',
      fontStyle: 'normal',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '20px',
      [theme.breakpoints.down('md')]: {
        width: '48%'
      },
      '&:first-of-type': {
        backgroundColor: '#2C62C7',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#1E4A8E'
        }
      },
      '&:last-of-type': {
        backgroundColor: '#000000',
        color: '#FFFFFF',
        '&:hover': {
          backgroundColor: '#333333'
        }
      }
    }
  })),

  UserTypeBadge: styled('span')<{ type: string }>(({ theme, type }) => ({
    backgroundColor: {
      Corretor: '#04682E',
      Secretária: '#FF0000',
      Proprietário: '#000000',
      Administrador: '#808080'
    }[type],
    color: 'white',
    padding: '12px 11px',
    borderRadius: '12px',
    fontSize: '12px',
    marginLeft: '8px',
    [theme.breakpoints.down('md')]: {
      marginLeft: '0',
      padding: '7px 6px'
    }
  })),

  Pagination: styled('div')(({ theme }) => ({
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '5px',
    marginTop: '15px',
    marginBottom: '25px',
    padding: '0 20px',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
      padding: '0 10px 25px 0',
      gap: '10px'
    },
    button: {
      padding: '8px 12px',
      [theme.breakpoints.up('md')]: {
        padding: '8px 16px'
      },
      cursor: 'pointer',
      color: 'black',
      border: '1px solid #ddd',
      backgroundColor: 'white',
      borderRadius: '5px',
      fontSize: '14px',
      '&.active': {
        backgroundColor: 'black',
        color: 'white'
      },
      '&:disabled': {
        cursor: 'not-allowed',
        backgroundColor: 'white',
        color: 'black'
      }
    }
  })),

  PageContainer: styled('div')({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f0f0f0'
  }),

  ContentContainer: styled('div')({
    display: 'flex',
    flex: 1
  }),

  EditButton: styled(Button)({
    width: '130.12px',
    height: '47.6px',
    backgroundColor: '#000000',
    borderRadius: '10px',
    color: '#FFFFFF',
    fontSize: '16px',
    fontWeight: 400,
    '&:hover': {
      backgroundColor: '#333333'
    }
  }),
  FlexRow: styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px'
  }),

  UserContact: styled('div')({
    color: '#666',
    fontSize: '14px',
    lineHeight: 1.4,
    '& div': {
      marginBottom: '3px'
    }
  }),

  ViewButton: styled(Button)({
    background: '#125dae',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    '&:hover': {
      background: '#0B327A'
    }
  }),

  DeleteButton: styled(Button)({
    background: '#ff4444',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '4px',
    '&:hover': {
      background: '#cc0000'
    }
  }),
  PropertyListContainer: styled('div')({
    padding: '90px',
    paddingTop: '60px',
    margin: '0 10px',
    backgroundColor: '#EBEBEB',
    display: 'flex',
    flexDirection: 'column',
    gap: '40px'
  })
};
